import type { DescLine } from '../../services/TrinketDescriptionService';
import './DescLines.scss';

export const DescLines = ({ lines }: { lines: DescLine[] }) => {
  if (lines.length === 0) {
    return null;
  }
  return (
    <ul className="desc-lines">
      {lines.map((l, i) => (
        <li key={i} className={`desc-line desc-line--${l.tone}`}>
          <span className="desc-label">{l.label}</span>
          {l.delta && (
            <span className="desc-delta">
              {l.delta.value >= 0 ? '+' : ''}
              {l.delta.value}
              {l.delta.percent ? '%' : ''}
            </span>
          )}
        </li>
      ))}
    </ul>
  );
};
